module.exports = __webpack_public_path__ + "static/media/e8.81b2fdf2.gif";